import React, { Component } from 'react';
import Logo from './../../assets/static/logo-home.png';

class Home extends Component {
  render() {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center h-100">
        <img src={Logo} alt="SOLFIN DEL SURESTE" className="img-fluid" />
      </div>
    );
  }
}

export default Home;
